import React from 'react';
import { CheckCircle } from 'lucide-react';

const AboutSection = ({ data }) => {
  return (
    <div className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div>
              <span className="inline-block px-4 py-2 rounded-full bg-amber-100 text-amber-800 text-sm font-semibold mb-4">
                About Us
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight">
                {data.title}
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed">
                {data.description}
              </p>
            </div>

            {/* Highlights */}
            <div className="space-y-4">
              {data.highlights.map((highlight, index) => (
                <div 
                  key={index}
                  className="flex items-center group hover:translate-x-2 transition-transform duration-300"
                >
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-amber-100 flex items-center justify-center group-hover:bg-amber-600 transition-colors duration-300">
                    <CheckCircle className="w-6 h-6 text-amber-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <span className="ml-4 text-lg font-medium text-slate-700 group-hover:text-slate-900 transition-colors duration-300">
                    {highlight}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Visual Element */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="aspect-[4/3] bg-gradient-to-br from-slate-800 via-slate-700 to-slate-900 flex items-center justify-center">
                <div className="text-center p-12">
                  <div className="text-7xl font-bold text-amber-500 mb-4">JV3</div>
                  <div className="text-2xl font-semibold text-white mb-2">Enterprise</div>
                  <div className="text-slate-400 text-lg">Premium Bitumen Export</div>
                </div>
              </div>
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-amber-500/20 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-blue-500/20 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
